import { getCurrentApi } from './baseAPI';

/**
 * Order Audit API service
 *
 * Endpoints:
 *   GET /admin-api/v1/audits/orders/:orderId  — full timeline
 *   GET /admin-api/v1/audits/orders            — paginated list
 */
export const orderAuditAPI = {
    /**
     * Get the full timeline (all report entries) for a specific order.
     * @param {string} orderId
     */
    getTimeline: async (orderId) => {
        try {
            const api = await getCurrentApi();
            const response = await api.get(`/audits/orders/${orderId}`);
            return response.data;
        } catch (error) {
            console.error('[orderAuditAPI] getTimeline error:', error);
            throw error;
        }
    },

    /**
     * List orders with their latest audit status.
     * @param {Object} options - { page, limit, userId, eventType, symbol, startDate, endDate }
     */
    listOrders: async (options = {}) => {
        try {
            const api = await getCurrentApi();
            const params = new URLSearchParams();

            if (options.page) params.append('page', options.page);
            if (options.limit) params.append('limit', options.limit);
            if (options.orderId) params.append('orderId', options.orderId);
            if (options.userId) params.append('userId', options.userId);
            if (options.eventType) params.append('eventType', options.eventType);
            if (options.symbol) params.append('symbol', options.symbol);
            if (options.startDate) params.append('startDate', options.startDate);
            if (options.endDate) params.append('endDate', options.endDate);

            const query = params.toString();
            const response = await api.get(`/audits/orders${query ? `?${query}` : ''}`);
            return response.data;
        } catch (error) {
            console.error('[orderAuditAPI] listOrders error:', error);
            throw error;
        }
    }
};
